module.exports = __webpack_public_path__ + "static/img/test-bg-4.a7123a2c.png";